// extracted by mini-css-extract-plugin
export default {"PopoverLayer":"📚19-10-2MBxkh"};